<template lang='pug'>
//- 隱私權政策
div(:class='$style[`cc-popbox-privacy-agreement`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(
    :class='$style[`cc-privacy-agreement-content`]'
    ref='scrollContainer'
    @scroll='handleScroll')
    div(:class='$style[`cc-privacy-agreement-container`]')
      div(:class='$style[`cc-container-wrap`]')
        div.font-bold(:class='$style[`cc-privacy-agreement-subtitle`]') 請詳閱並同意以繼續使用
        div.font-bold(:class='$style[`cc-privacy-agreement-title`]') 隱私權政策、個資保護聲明
        div(:class='$style[`cc-container-wrap-list`]')
          div(:class='$style[`cc-container-info`]')
            span 親愛的使用者，您的個人資料及隱私權益，健細胞科技股份有限公司(以下簡稱「Cancell」)絕對尊重及保護。當您使用本服務時，本公司將遵循「個人資料保護法」之規範蒐集、處理及利用您提供之個人資料。為了提供良好的服務，本公司會在您使用本服務之期間或法律所允許之期間內留存您之相關個人資料，但非經您書面同意，或有其他合法使用依據，本公司不會將個人資料用於其他逾越本服務條款所說明之用途。本公司也有可能透過合法途徑從商業夥伴處取得與暫存您的個人資料以優化本服務。為了確保您之個人資料受保護，本公司謹依個人資料保護法規定告知以下事項並取得您之同意：

        div(:class='$style[`cc-container-wrap-list`]')
          h1.font-medium 一、個人資料蒐集之目的
          div(:class='$style[`cc-container-info`]')
            span 蒐集之目的在於透過本服務提供您智慧醫療服務，例如協助您管理您 (包含您依法有權或經授權為其行使權利義務之親友) 的個人健康資訊 (包括症狀紀錄、病理檔案、診斷報告、飲食與血壓血糖照片、醫病諮詢對話紀錄等)，並進行合法的醫事資訊推廣、保健醫療服務、客戶管理與服務、學術研究，及調查、統計與研究分析，明文使用類別將如下所示：
            table(border="1" cellspacing="1" style="border:3px solid black;border-collapse:collapse;width:100%;")
              thead
                tr
                  th 特定目的及代號
                  th 特定目的說明

              tbody
                tr
                  td 063
                  td 非公務機關依法定義務所進行個人資料之蒐集處理及利用
                tr
                  td 064
                  td 保健醫療服務
                tr
                  td 069
                  td 契約、類似契約或其他法律關係事務
                tr
                  td 081
                  td 個人資料之合法交易業務
                tr
                  td 090
                  td 消費者、客戶管理與服務
                tr
                  td 091
                  td 消費者保護
                tr
                  td 098
                  td 商業與技術資訊
                tr
                  td 135
                  td 資 (通) 訊服務
                tr
                  td 137
                  td 資通安全與管理
                tr
                  td 157
                  td 調查、統計與研究分析
                tr
                  td 176
                  td 其他自然人基於正當性目的所進行個人資料之蒐集處理及利用
                tr
                  td 182
                  td 其他諮詢與顧問服務
                tr
                  td C011
                  td 個人描述
                tr
                  td C012
                  td 身體描述
                tr
                  td C013
                  td 習慣
                tr
                  td C111
                  td 健康紀錄

        div(:class='$style[`cc-container-wrap-list`]')
          h1.font-medium 二、個人資料之類別：
          div(:class='$style[`cc-container-info`]')
            span 本服務蒐集的個人資料包括以下類別：
            span (一) 辨識個人者：姓名、電話、身份證資料 (部分功能需提供)、LINE ID、網路平臺申請之帳號、提供網路身分認證或申辦查詢服務之紀錄及其他由您所提供之任何可辨識資料本人者。
            span (二) 個人描述：性別、出生年月日。
            span (三) 身體描述：身高、體重、血壓、血糖。
            span (四) 健康紀錄：病史、醫療報告、治療與診斷紀錄、診斷結果、個管計畫、預防保健、標籤、院所註記、衛教紀錄、居家症狀回報數據。

        div(:class='$style[`cc-container-wrap-list`]')
          h1.font-medium 三、資料之利用
          div(:class='$style[`cc-container-info`]')
            span 我們對於您的個人資料，將依我們蒐集時所闡述之特定目的及相關法令規定之範圍內使用(例如:發送電子報、建立會員檔案、向您通知服務相關資訊等)。除非取得您的同意或依其他法令特別規定，我們絕不會將您的個人資料揭露予第三人、在我們營運地區以外之區域處理或利用，或使用於蒐集目的以外之其他用途。若因提供服務有必要委託關係企業或第三人(例如醫療院所、生醫企業、金流業者、資訊服務業者等)時，我們會執行必要的監督，以確保您的個人資料安全。

        div(:class='$style[`cc-container-wrap-list`]')
          h1.font-medium 四、資料之保護
          div(:class='$style[`cc-container-info`]')
            span (一) 我們將以嚴密的保護措施保護您的個人資料，蒐集、處理或利用您個人資料之網路、系統、程式、終端、人員均已納入我們的資通安全防護範圍，符合相關主管機關嚴格要求，防止未經授權人員之接觸。此外，我們對內部人員亦施予完善個資保護訓練，如有違反保密義務者，將受相關法律及公司內部規定之處分。
            span (二) 使用者自我保護措施：建議您優先透過「LINE一鍵登入方式」註冊會員。若透過手機號碼或電子信箱註冊方式，請妥善保管您的密碼及或任何個人資料，不要將任何個人資料，尤其是密碼提供給任何人。若您是與他人共享電腦或使用公共電腦，切記要關閉瀏覽器視窗並確認登出，以防止他人讀取您的個人資料或隱私資料。若您將上開個人資料提供予他人，您必須自行承擔個人資料外洩的風險與責任。

        div(:class='$style[`cc-container-wrap-list`]')
          h1.font-medium 五、Cookie之運用
          div(:class='$style[`cc-container-info`]')
            span 我們的網站或應用程式伺服器將會使用Cookie以紀錄及分析使用者行為，以提供客製化內容，並優化您的使用體驗。這些資訊僅⽤於進⾏數據性的統計分析，不涉及您的個⼈⾝分資料，將作為改進我們的產品、服務、網站內容、系統、AI服務品質之⽤。您可以在瀏覽器修改對Cookie的接受程度，如果您選擇拒絕所有的Cookie，可能會導致某些功能無法正常執行。

        div(:class='$style[`cc-container-wrap-list`]')
          h1.font-medium 六、與第三者共用個人資料之情形
          div(:class='$style[`cc-container-info`]')
            span 我們絕對不會任意交換、出租或以其他變相之方式，將您的個人資料揭露予第三人。但依法令規定或得到您的同意，我們會與第三人共用您的個人資料：
            span (一) 配合司法單位依法所為的調查。
            span (二) 配合政府機關依法令或職權之調查或使用(例如主管機關為緊急避難、維護公共利益、打擊犯罪或維持社會秩序，依法向我們調閱或查詢您的資料等)。
            span (三) 基於委外契約關係，我們依約履行予代我們處理個人資料的供應商。

        div(:class='$style[`cc-container-wrap-list`]')
          h1.font-medium 七、隱私權保護政策之修正及諮詢
          div(:class='$style[`cc-container-info`]')
            span (一) 為確實保障您的隱私權，在法律所允許的範圍內，我們保留隨時修正本政策的權利，我們最近一次更新本政策的時間是2025年09月10日。修正後的條款將公告於我們的網站、APP，且自公告日起生效。
            span (二) 如您於本政策為任何修改或變更後仍繼續使用我們的網站、APP服務，即表示您已閱讀、瞭解並同意遵守本政策的修改或變更。

      div(:class='$style[`cc-container-wrap`]')
        div.font-bold(:class='$style[`cc-privacy-agreement-title`]' style='padding-top: 40px') 服務使用條款
        div(:class='$style[`cc-container-wrap-list`]')
          div(:class='$style[`cc-container-info`]')
            span Cancell 遠距醫療（以下簡稱Cancell）是由健細胞科技股份有限公司（下稱本公司）所建置。本公司係依照本網站服務使用條款（以下簡稱「本條款」），提供本企業用戶及一般公眾使用本網站各項網路資訊服務（下稱「網站服務」），使用本網站前請務必詳細閱讀本條款內容以保障權益，當您已開始使用本網站服務時，視為已確實閱讀、瞭解並同意遵守本條款。
            span 本公司有權隨時修改或變更本條款之內容，並自公告於本網站時起生效。您於本條款為任何修改或變更後仍繼續使用本公司網站服務時，視為已確實閱讀、瞭解並同意遵守本條款之修改或變更。若您未具完全行為能力，除您本人應遵守上述規定外，並請您的法定代理人同時確實閱讀、瞭解並同意遵守本條款之所有內容，方得使用本網站服務；當您於本條款為修改或變更後仍繼續使用本網站服務時，即表示您的法定代理人亦已確實閱讀、瞭解並同意遵守本條款之修改或變更。

        div(:class='$style[`cc-container-wrap-list`]')
          h1.font-medium 一、服務內容及基本規範
          div(:class='$style[`cc-container-info`]')
            span (一) 本公司係透過網際網路提供各項網站服務，您得於本網站瀏覽、查詢、申請或使用本公司各項服務或取得個人化健康建議。
            span (二) 本網站服務所提供之健康資訊、AI諮詢與個人衛教服務並非正規治療，如有嚴重症狀請務必至醫院掛號看診進行治療。除本公司與您另有約定者外，本公司的提供之健康資訊、AI諮詢與個人衛教服務，並不保證資訊之正確性，請優先以您的主治醫師治療與診斷建議為主，本公司不擔負任何責任。

        div(:class='$style[`cc-container-wrap-list`]')
          h1.font-medium 二、服務使用責任與義務
          div(:class='$style[`cc-container-info`]')
            span (一) 您所提供之個人資料如有填寫不實、原所登錄資料已不符合真實而未更新、所提供之個人資料違反或破壞本公司服務宗旨或有任何誤導之虞者，本公司有權拒絕提供您使用網站服務之一部或全部。
            span (二) 您於使用本網站服務時，除應遵守中華民國法令、國際網際網路規定與慣例及本條款規範外，並不得有下列行為，如您違反規定，致本公司或合作夥伴、受僱/任人、代理人及其他履行輔助人受有損害或支出費用（包括但不限於訴訟費及律師費）者，應負損害賠償責任。如有涉犯刑事犯罪者，本公司並得移請主管機關或司法單位處理。
              ul
                li 有損他人人格或商標權、著作權等智慧財產權或其他權利內容。
                li 未經同意複製、轉載、轉售他人資訊。
                li 未經本公司許可，利用本網站服務所提供之資源，包括但不限於圖文、網頁、程式碼等，從事任何商業交易行為，或招攬廣告商或贊助人。
                li 使用違反公共秩序或善良風俗或強烈政治、宗教色彩的偏激言論或其他不法之文字。
                li 傳輸或散佈色情、猥褻、虛偽不實或其他違反善良風俗之言論或資訊。
                li 冒用他人名義註冊為網路會員或擅自登入他人帳號。
                li 傳輸或散佈電腦病毒或為其他任何可能破壞、毀損或干擾本公司本服務之行為。
                li 其他違反本條款之行為。
            span (三) 您應妥善保管會員帳號及密碼，勿將該組帳號及密碼洩露予第三人知悉、出借或轉讓第三人使用，並為該組帳號與密碼登入本網站系統後所進行之一切活動負責，包括查詢、檢索、閱覽、更改個人資料、參與各項活動、取得消費資訊、訂閱商品或服務及其他涉及個人權益之類似行為等。如有外洩或遭到盜用等，應即通知本公司，惟本公司不對損害負擔任何責任。
            span (四) 您同意授權本公司對您所公佈、張貼、上傳至本網站之資料訊息及著作享有公開散佈、發行、重製、修改，編輯、轉載、再授權與他人、轉售或刪除之權利。
            span (五) 本網站所提供會員之重設密碼電子信件、健康分析報告電子報皆應視為機密，應予以嚴格保密，如未盡保密義務所生之損害概由會員自行負責。

        div(:class='$style[`cc-container-wrap-list`]')
          h1.font-medium 三、服務之停止或終止
          div(:class='$style[`cc-container-info`]')
            span (一) 本網站如發生下列情形之一，本公司有權不經通知逕行停止或中斷提供服務，且不負任何法律責任：
              ul
                li 發生突發性之電子通信設備故障時；
                li 由於所申請之電子通信服務因任何原因被停止，無法提供服務時；
                li 因不可抗力因素或不可歸責本公司事由致無法提供服務或造成服務停止或中斷時。
                li 對於本網站相關系統設備進行遷移、更換或維護時。
            span (二) 基於網際網路之特性，您瞭解並同意於使用本網站服務時，應自行採取防護措施，如因會員電子設備遭駭、誤觸釣魚網站而導致帳號密碼外洩，或遭第三人侵入系統篡改偽造資料等，本公司不負任何賠償責任。
            span (三) 如您有違反本條款、相關法令或有其他不當使用本網站之情形，本公司得不經催告逕行加以限制或終止您使用網站服務之權利，您不得因此要求補償或賠償。

        div(:class='$style[`cc-container-wrap-list`]')
          h1.font-medium 四、免責聲明
          div(:class='$style[`cc-container-info`]')
            span (一) 本公司就網站服務不負任何明示或默示之擔保責任，且不保證網站服務之穩定、安全、無誤及不中斷，亦不保證本網站資訊內容之正確、完整及適當得宜。但本公司願對您的申訴進行妥適瞭解，並適度反應予提供資訊或產品之廠商。
            span (二) 本網站如有無法使用、失誤刪除、備份儲存失敗等情形，致生有直接、間接、衍生、或特別損害等，本公司均不負任何賠償責任。
            span (三) 本公司對於您使用本服務或經由本服務連結至其他網站而下載之軟體或資料，不負任何擔保及賠償責任。您應於下載前自行斟酌判斷前述軟體或資料之合適性、有效性、正確性、完整性及是否侵害他人權利，以免遭受電腦系統受損或儲存資料流失等損害。
            span (四) 本網站如有提供連結至其他個人、公司或組織之網站，僅為便利您自行蒐集或取得資訊，本公司對該被連結網站所提供之商品、服務及資訊，不擔保其真實、完整、即時或可信度。該被連結網站所屬之個人、公司或組織亦不因此當然與本公司有任何委任、代理或其他合作之關係。

        div(:class='$style[`cc-container-wrap-list`]')
          h1.font-medium 五、權利歸屬及智慧財產權
          div(:class='$style[`cc-container-info`]')
            span 本網站所使用或提供之軟體、程式及內容（包括但不限於文字、說明、圖畫、圖片、圖形、檔案、頁面設計、網站規劃與安排等）之專利權、著作權、商標權、營業秘密、專門技術及其他智慧財產權均屬本公司或其他權利人所有，非經權利人事先書面授權同意，不得重製、公開傳播、公開播送、公開上映、改作、編輯、出租、散布、進行還原工程、解編、反向組譯、或以其他任何形式、基於任何目的加以使用，如有違反，除應自負法律責任外，倘對本公司造成損害，本公司有權請求損害賠償。

        div(:class='$style[`cc-container-wrap-list`]')
          h1.font-medium 六、準據法及管轄法院
          div(:class='$style[`cc-container-info`]')
            span (一) 本條款之解釋或適用，以中華民國法律為準據法。
            span (二) 如您因使用網站服務與本公司產生爭議，同意依誠信原則解決，如有訴訟之必要，同意以臺灣臺北地方法院為第一審管轄法院。

        div(:class='$style[`cc-container-wrap-list`]')
          h1.font-medium 七、本條款修訂權利
          div(:class='$style[`cc-container-info`]')
            span 本公司有權隨時修正本條款，修正之內容自本網站公告時起生效，不另行個別通知，您不得因此而要求任何補償或賠償。

        div(:class='$style[`cc-container-wrap-list`]')
          h1.font-medium 八、與我們聯絡
          div(:class='$style[`cc-container-info`]')
            span 如果您對Cancell服務有任何疑問，請利用以下方式與Cancell聯絡：
            ul
              li.font-doctor-theme 服務時間：週一至週五：10:00 - 18:00
              li.font-doctor-theme 服務信箱：
                a.font-doctor-theme(href='mailto:service@cancell.ai' target='_blank') service@cancell.ai
              li.font-doctor-theme 官方Line：
                a.font-doctor-theme(href='https://lin.ee/eEea6j5' target='_blank') https://lin.ee/eEea6j5
            span 感謝您閱讀此條款。希望您盡情享受Cancell所提供的服務！

  div(:class='$style[`cc-content-privacy-agreement-control`]')
    button.btn-extra(
      title='關閉'
      tabindex='0' aria-label='關閉'
      :class='$style[`cc-content-privacy-agreement-close`]'
      @click='handleClosePopBox')
      span 關閉

    button.btn-confirm-extra(
      title='我已閱讀並同意'
      tabindex='0' aria-label='我已閱讀並同意'
      :class='[$style[`cc-content-privacy-agreement-agree`], $style[isAtBottom ? `` : `cc-disabled`]]'
      :disabled='!isAtBottom'
      @click='confirmReadAgreement')
      span {{ isAtBottom ? '我已閱讀並同意' : '請向下滾動至底部' }}

</template>

<script>
import { mapMutations } from 'vuex';
import GlobalEmitter from 'tiny-emitter/instance';

export default {
  data() {
    return {
      isAtBottom: false,
    };
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changePopAnalysisStatus: 'global/POPANALYSIS_STATUS',
      changePopCourseStatus: 'global/POPCOURSE_STATUS',
    }),

    handleClosePopBox() {
      this.changePopBoxStatus({
        active: false,
        includes: '',
      });
    },

    confirmReadAgreement() {
      console.log('正在觸發 loadMoreData 事件...');
      GlobalEmitter.emit('create-agreement', true);
    },

    handleScroll() {
      // 透過 this.$refs 取得 DOM 元素
      const container = this.$refs.scrollContainer;
      // 如果元素不存在，就直接返回
      if (!container) return;

      // 使用 toFixed 處理可能的浮點數問題，或直接比較
      // 加上一個小小的容錯值（例如 1px）會更穩定
      const isScrolledToBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 200;

      if (isScrolledToBottom) {
        this.isAtBottom = true;
      } else {
        // 如果滾動條離開底部，可以重置狀態
        this.isAtBottom = false;
      }
    },
  },

  // eslint-disable-next-line vue/order-in-components
  // computed: {
  //   ...mapGetters({
  //   }),
  // },
};
</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popReadAgreement.scss';
</style>
